import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import DashboardContainer from "../pages/Dashboard/DashboardContainer";
import AlquileresContextProvider from "../context/AlquileresContext";
import NotasContextProvider from "../context/NotasContext";
import ActividadContextProvider from "../context/ActividadContext";

function PrivateRoute() {
  const { user } = useAuthContext();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <AlquileresContextProvider>
      <NotasContextProvider>
        <ActividadContextProvider>
          <DashboardContainer>
            <Outlet />
          </DashboardContainer>
        </ActividadContextProvider>
      </NotasContextProvider>
    </AlquileresContextProvider>
  );
}

export default PrivateRoute;
